var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div layout=\"row\" layout-align=\"start start\" layout-sm=\"column\" layout-align-sm=\"center center\" layout-xs=\"column\" layout-align-xs=\"center center\" layout-fill>\n<div style=\"width: 50%;\" layout=\"column\" layout-align=\"center end\" layout-align-sm=\"center center\" layout-align-xs=\"center center\">\n<content-nav-widget></content-nav-widget>\n</div>\n<div style=\"width: 50%;\" layout=\"column\" layout-align=\"center start\" layout-align-sm=\"center center\" layout-align-xs=\"center center\">\n<fpp-widget></fpp-widget>\n</div>\n</div>\n";
var id1="admin/setup/landing.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/admin/setup/landing.html
// module id = 635
// module chunks = 0